import React, { FC, useEffect } from 'react';
import { WixDesignSystemProvider } from '@wix/design-system';
import { GLOBAL_DESIGN_ACTIONS } from './actions';
import { GlobalDesignActionType, GlobalDesignPanelProps } from './types';
import { DefaultActionPanel } from './DefaultActionPanel';
import { GroupsActionPanel } from './GroupsActionPanel';
import { TranslationContext } from '../useTranslation';
import { EditorPlatformBIProvider } from '../providers/EditorPlatformBIProvider';
import { ExperimentsProvider } from '../providers/ExperimentsProvider';

const EDITOR_PLATFORM_SCOPE = 'editor-platform';

export const GlobalDesignPanel: FC<GlobalDesignPanelProps> = (
  props: GlobalDesignPanelProps,
) => {
  useEffect(() => {
    import('@wix/design-system/styles.global.css');
  }, []);

  const action = GLOBAL_DESIGN_ACTIONS[props.actionName];

  if (!action) {
    return null;
  }

  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <ExperimentsProvider scope={EDITOR_PLATFORM_SCOPE}>
        <EditorPlatformBIProvider>
          <TranslationContext.Provider value={props.t}>
            {action.type === GlobalDesignActionType.Group ? (
              <GroupsActionPanel {...props} action={action} />
            ) : (
              <DefaultActionPanel {...props} action={action} />
            )}
          </TranslationContext.Provider>
        </EditorPlatformBIProvider>
      </ExperimentsProvider>
    </WixDesignSystemProvider>
  );
};
